import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { QueueListIcon } from '@heroicons/react/24/outline';

interface ModelRequestsSubmenuProps {
  collapsed: boolean;
  onMobileClose?: () => void;
}

export const ModelRequestsSubmenu: React.FC<ModelRequestsSubmenuProps> = ({ collapsed, onMobileClose }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith('/model-requests');

  return (
    <NavLink
      to="/model-requests"
      onClick={onMobileClose}
      className={clsx(
        'group flex items-center px-4 py-3 text-white/80 hover:bg-white/10 hover:text-white transition-all duration-200',
        isActive && 'bg-white/10 text-white border-l-4 border-white/60',
        collapsed && 'justify-center px-0'
      )}
      title={collapsed ? 'Model Requests' : undefined}
    >
      <QueueListIcon className={clsx(
        'w-5 h-5 flex-shrink-0 transition-transform duration-200 group-hover:translate-x-0.5',
        collapsed && 'mx-auto'
      )} />
      {!collapsed && <span className="ml-3">Model Requests</span>}
    </NavLink>
  );
};
